import { ReactComponent as ClinicalHistoryIcon } from 'assets/icons/clinical-history.svg'
import { ToolBarButton } from 'components/ToolBarButton'

export const ClinicalHistoryButton = () => {
  const handleClick = () => {
    console.info('CLINICAL HISTORY button clicked')
  }

  return (
    <ToolBarButton
      disabled={false}
      label="CLINICAL HISTORY"
      icon={ClinicalHistoryIcon}
      tooltipText="CLINICAL HISTORY"
      clickCallback={handleClick}
      badgeStatus="alert"
    />
  )
}
